export default __webpack_public_path__ + "static/media/payments-white.63be1844.svg";